import { ref, computed, watch } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import ability from '@/libs/acl/ability'
import { debounce } from 'lodash'
import useFilterCounter from '@/components/Filters/useFiltersCount'
import moment from "moment";

export default function useList() {
  const refListTable = ref(null)
  const toast = useToast()
  const filters = ref({});
  const filtersCount = useFilterCounter(filters);

  store.dispatch('type_alarm/getAll')
  store.dispatch('pacom_alarm_types/getAll', { isList: true })


  const tableColumns = [
    {
      label: 'pacom.typeAlarm',
      key: 'type_alarm.name'
    },
    {
      label: 'pacom.state',
      key: 'state'
    },
    {
      label: 'pacom.priority',
      key: 'priority'
    },
    {
      label: 'pacom.priority',
      key: 'priority'
    },
    {
      label: 'pacom.creation_time',
      key: 'creation_time',
      formatter: (value) => {
        return moment.utc(value).tz('Etc/GMT+6').format('YYYY-MM-DD HH:mm:ss')
      }
    }
  ]


  const displayNameFilter = ref(null)
  const startDatetimeFilter = ref(null)
  const endDatetimeFilter = ref(null)


  const perPage = ref(10)
  const totalList = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)

  const pacomTypeAlarms = computed(() => store.getters['pacom_alarm_types/getSelectedItems'])
  const typeAlarms = computed(() => store.getters['type_alarm/getSelectedItems'])

  const pacomTypeAlarmsFilter = ref(null)
  const typeAlarmsFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalList.value,
    }
  })

  const buildFilters = () => {
    filters.value = {
      startDate: startDatetimeFilter.value,
      endDate: endDatetimeFilter.value,
      typeAlarm: typeAlarmsFilter.value,
      pacomTypeAlarm: pacomTypeAlarmsFilter.value
    }

    refetchData();
  }

  const clearSearchFilters = () => {
    typeAlarmsFilter.value = null;
    pacomTypeAlarmsFilter.value = null;
    startDatetimeFilter.value = null;
    endDatetimeFilter.value = null;

    buildFilters();
  }

  const fetchList = (ctx, callback) => {
    store.dispatch('pacom_alarms/getAll', {
      q: searchQuery.value,
      max: perPage.value,
      'page[n]': currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      display_name: displayNameFilter.value,
      typeAlarm: typeAlarmsFilter.value,
      pacomTypeAlarm: pacomTypeAlarmsFilter.value,
      startDate: startDatetimeFilter.value,
      endDate: endDatetimeFilter.value,
    })
      .then(response => {
        callback(response.data)
        totalList.value = response.meta.total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error obteniendo la información',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  const refetchData = () => {
    refListTable.value.refresh()
  }

  watch([currentPage, perPage], () => {
    refetchData()
  })

  watch([searchQuery], debounce(() => {
    refetchData()
  }, 500))

  return {
    tableColumns,
    perPage,
    currentPage,
    totalList,
    fetchList,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refListTable,
    displayNameFilter,

    pacomTypeAlarms,
    typeAlarms,
    pacomTypeAlarmsFilter,
    typeAlarmsFilter,
    startDatetimeFilter,
    endDatetimeFilter,

    refetchData,
    clearSearchFilters,
    buildFilters,
    filtersCount
  }
}
